import { forwardRef, InputHTMLAttributes } from 'react';

/**
 * UiCheckbox - Standardized checkbox matching AngularJS Bootstrap styles
 *
 * Provides consistent 13x13px sizing matching AngularJS Bootstrap checkboxes.
 */

export interface UiCheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  /** Additional CSS classes */
  className?: string;
}

export const UiCheckbox = forwardRef<HTMLInputElement, UiCheckboxProps>(
  ({ className = '', ...props }, ref) => {
    const baseClasses =
      'w-[13px] h-[13px] rounded border-angular-border text-angular-link-primary focus:ring-angular-focus-ring disabled:cursor-not-allowed disabled:bg-angular-input-disabled-bg';

    return (
      <input
        ref={ref}
        type='checkbox'
        className={`${baseClasses} ${className}`.trim()}
        {...props}
      />
    );
  }
);

UiCheckbox.displayName = 'UiCheckbox';
